import { useEffect } from "react";
import { Provider } from "react-redux";
import Head from "next/head";
import { usePathname } from "next/navigation";
import type { AppProps } from "next/app";
import { wrapper } from "@app/store/store";
import { montserrat } from "@app/styles/fonts";
import { AuthCheck } from "@features/auth/AuthCheck";
import "@app/styles/globals.scss";

function App({ Component, ...rest }: AppProps) {
    const pathname = usePathname();
    const { store, props } = wrapper.useWrappedStore(rest);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes"
                />
            </Head>
            <Provider store={store}>
                <style jsx global>{`
                    html {
                        font-family: ${montserrat.style.fontFamily};
                    }
                `}</style>
                <AuthCheck>
                    <Component {...props.pageProps} />
                </AuthCheck>
            </Provider>
        </>
    );
}

export default App;